import React, { Component } from 'react';
import * as UA_INFO from '@umu/umu-ua';
import { classSet } from '@umu/umu-dom';
import './navBar.scss';

interface IProps {
    defaultUrl?: string;
    title?: string | JSX.Element;
    isForceShow?: boolean;
    isForceCenterTitle?: boolean; // 是否强制标题居中，默认右边无元素时居中标题。
    isMultiple?: boolean;   // 是否多行展示
    showShadow?: boolean;
    hideBack?: boolean;
    className?: string;
    onBack?(): void;
    afterIcon?: JSX.Element;
}

export default class NavBar extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.go = this.go.bind(this);
    }
    public isBackSuccess = false;
    public onPopState = () => {
        this.isBackSuccess = true;
        // 可以在这里移除监听器，因为它不再需要了
        window.removeEventListener('popstate', this.onPopState);
    }
    public go() {
        const { defaultUrl, onBack } = this.props;
        if (defaultUrl) {
            window.location.href = defaultUrl;
        } else if (onBack) {
            onBack();
        } else if (window.history.length > 1) {
            window.addEventListener('popstate', this.onPopState);

            history.back();
            // 延迟一些时间后检查后退是否成功
            setTimeout(() => {
                if (!this.isBackSuccess) {
                    window.location.href = '/';
                }
            }, 500)
        }
    }

    public renderPreIcon() {
        if (!this.props.hideBack
            && (window.history.length > 1
                || this.props.defaultUrl
                || this.props.onBack)
        ) {
            return (
                <button className="imitate-a back-btn" onClick={this.go}>
                    <i className="icon icon-arrow-black" />
                </button>
            );
        }
        return null;
    }

    public renderAfterIcon(){
        if(this.props.afterIcon){
            return <div className='nav-bar-after-icon'>{this.props.afterIcon}</div>;
        }
        return null;
    }

    public render() {
        const { className, isMultiple } = this.props;
        if (!this.props.isForceShow && (UA_INFO.isWeixinBrowser || UA_INFO.isUMUWebview)) {
            return null;
        } else {
            const containerCls = classSet({
                'nav-bar': true,
                'nav-shadow': !!this.props.showShadow,
            });
            const titleCls = classSet({
                'title': true,
                'nav-center-title': this.props.isForceCenterTitle || !this.props.children,
            });
            return (
                <div className={`${containerCls} ${className || ''} ${isMultiple ? 'multiple-lines' : 'one-line'}`}>
                    {this.renderPreIcon()}
                    <div className={titleCls}>{this.props.title}</div>
                    {this.renderAfterIcon()}
                    {this.props.children}
                </div>
            );
        }
    }
}
